import React, {useContext} from 'react';
import {Controller} from "react-hook-form";
import {FormControl, FormHelperText, InputLabel, MenuItem, Select} from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import {getHelperStyle} from "../../../styles/components/FormStyle";
import {isEmpty} from "../../../utils/GenericUtils";
import {AppContext} from "../../../App";
import {languages} from "../../../strings/LanguageDictionary";
import {MenuProps} from "../../../styles/components/DynamicComponentStyle";


const CustomSelect = ({
                          name, label, control, defaultValue,
                          children, autoFocus, disabled, none,
                          noneValue, tooltip, title, rules, error
                      }) => {
    const labelId = `${name}-label`;
    const appContext = useContext(AppContext);

    return (
        <React.Fragment>
            {
                tooltip ?
                    <Tooltip
                        title={title}>
                        <FormControl disabled={disabled} variant={"outlined"} fullWidth={true}
                                     error={!isEmpty(error)} margin='dense'>
                            <InputLabel id={labelId}>{label}</InputLabel>
                            <Controller
                                as={
                                    <Select autoFocus={autoFocus} labelId={labelId} label={label} MenuProps={MenuProps} margin='dense'>
                                        {children}
                                        {
                                            none && <MenuItem value={noneValue}>
                                                <em>{languages[appContext.state.lang].OCEAN__GLOBAL_NON_SPECIFICATO}</em>
                                            </MenuItem>
                                        }
                                    </Select>
                                }
                                name={name}
                                control={control}
                                defaultValue={defaultValue}
                                rules={rules}
                            />
                        </FormControl>
                    </Tooltip> :
                    <FormControl disabled={disabled} variant={"outlined"} fullWidth={true}
                                 error={!isEmpty(error)} margin='dense'>
                        <InputLabel id={labelId}>{label}</InputLabel>
                        <Controller
                            as={
                                <Select required={rules.required} autoFocus={autoFocus} labelId={labelId} label={label}
                                        MenuProps={MenuProps}> margin='dense'
                                    {
                                        none && <MenuItem value={noneValue}>
                                            <em>{languages[appContext.state.lang].OCEAN__GLOBAL_NON_SPECIFICATO}</em>
                                        </MenuItem>
                                    }
                                    {children}
                                </Select>
                            }
                            name={name}
                            control={control}
                            defaultValue={defaultValue}
                            rules={rules}
                        />
                        {!isEmpty(error) && <FormHelperText
                            style={getHelperStyle().helper}>{languages[appContext.state.lang].OCEAN__GLOBAL_REQUIRED_FILES_}</FormHelperText>
                        }
                    </FormControl>
            }
        </React.Fragment>
    );
};

export default React.memo(CustomSelect);
